<script>
  import { onMount } from 'svelte';
  import Container from './components/Container.svelte';
  import WaitingFor from './components/WaitingFor.svelte';

  export let authenticate;
  export let setUser;
  export let router;

  let state = 'loading'; // signup | approve attempt | redirect | timeout | error | done
  let action;
  let approveTC = false;
  let staySignedIn = localStorage.getItem('telekinesisCloudSession') != null;
  let user;
  let path = '';
  let restrictAccess = false;
  let mode = 'admin';
  let timeout;
  let errorMessage = '';

  onMount(async () => {
    let searchParams = new window.URLSearchParams(window.location.search)

    let code = searchParams.get('code');
    let loginId = searchParams.get('state');

    if (code === null && loginId === null) {
      window.location.replace("https://github.com/login/oauth/authorize?client_id=f47143e3acd5b22afb26&scope=user:email")
    }

    user = authenticate((s, a) => {
      state = s;
      action = a; 
      // console.log(state, action)
      if (state == 'redirect') {
        window.location.replace(action)
      }}, loginId, code
    )._subscribe(console.log)
    await user;
    console.log('>>>', user, Array.from(user._state?.attributes?.values()))
    window.u22 = user
    if (user._state.attributes.has('id')) {
      console.log('>')
      setUser(user);
      router.replace(`/dashboard`);
    }
  })

  const storeSession = async () => {
    state = "loading";
    if (staySignedIn) {
      localStorage.setItem('telekinesisCloudSession', await user._session.sessionKey.exportKey());
    } else {
      localStorage.removeItem('telekinesisCloudSession');
    }
  }
  const approveStaySignedIn = async () => {
    await storeSession();
    await action(staySignedIn);
  }
  const approveAttempt = async (approve, path, mode, timeout) => {
    await storeSession();
    try {
      errorMessage = '';
      await action.approve_fn(approve, staySignedIn, path, mode, timeout);
    } catch (e) {
      errorMessage = e;
      state = "approve attempt";
    }
  }

</script>

<Container>
  {#if state === 'loading'}
    <WaitingFor message='loading' />
  {:else if state == 'signup'}
    <h2>Welcome {action.user_id} to Telekinesis.Cloud</h2>
    <form class="pure-form pure-form-stacked">
          <label for="accept-tc" class='pure-checkbox'>
            <input type="checkbox" id="accept-tc" name='use-interviewless' bind:checked={approveTC}/> I have read and approve the<a href="/tc">Terms and Conditions</a>
          </label>
      <button 
        type="submit"
        style="background-color: var(--primary); color: white"
        class="pure-button pure-button-primary" 
        disabled={!approveTC} 
        on:click={async e => {e.preventDefault(); state = "loading"; await action.approve_tc()}}
      > Continue
      </button>
    </form>
  {:else if state == "approve attempt"}
    <h2><span style="color: var(--secondary)">{action.user_id}</span>, do you approve the following login attempt?</h2>

    <div style="margin: 0 auto; text-align: left; max-width: 1000px;">
      <ul>
        {#each Object.keys(action.headers) as header}
          <li><strong>{header}: </strong>{action.headers[header]}</li>  
        {/each}
      </ul>
    </div>
    <label for="restrict-access" class='pure-checkbox'>
      <input type="checkbox" id="restrict-access" name='restrict-access' bind:checked={restrictAccess}/> Restrict access
    </label>
    {#if restrictAccess}
      <label for="path" class='pure-input'>
        Path: <input type="text" id="path" name='path' bind:value={path}/>
      </label>
      <label for="mode" class='pure-input'>
        Access mode: <input type="text" id="path" name='path' bind:value={mode}/>
      </label>
      <label for="timeout" class='pure-input'>
        Timeout: <input type="number" id="timeout" name='timeout' bind:value={timeout}/>
      </label>
    {/if}
    <label for="stay-signed-in" class='pure-checkbox'>
      <input type="checkbox" id="stay-signed-in" name='stay-signed-in' bind:checked={staySignedIn}/> Keep browser signed in
    </label>
    <button class="pure-button" on:click={async () => approveAttempt(false, '', undefined, undefined)}>Reject</button>
    <button class="pure-button" on:click={async () => 
      approveAttempt(true, restrictAccess ? path : '', restrictAccess ? mode: 'admin', restrictAccess ? (timeout ? timeout : null) : null)
    } style="background-color: var(--primary); color: white">Approve</button>
    {#if errorMessage}
      <p style="color: red">{errorMessage}</p>
    {/if}
  {:else if state == "store_session"}
    <label for="stay-signed-in" class='pure-checkbox'>
      <input type="checkbox" id="stay-signed-in" name='stay-signed-in' bind:checked={staySignedIn}/> Keep browser signed in
    </label>
    <button class="pure-button" on:click={approveStaySignedIn}>Continue</button>
  {:else if state == "timeout"}
    <h2>Login approval timed-out</h2>
  {:else if state == "error"}
    <h2>Login error</h2>
    <div style="padding: 20px; background-color: #ffa; color: #884;">
      {action}
    </div>
  {/if}
</Container>


<style>
  ul {
    padding-left: 0;
    list-style: none;
    font-size: 18px;
  }
</style>